import './YouTubeEmbedWrapper.scss';

import { useEffect, useRef, useState } from 'react';
import { YouTubeEmbed, type YouTubeEmbedProps } from 'react-social-media-embed';

const className = 'c-YouTubeEmbedWrapper';

const maxWidth = 720;

/**
 * @deprecated Migrate over to YoutubeIframe when CMS links are migrated
 */
export const YouTubeEmbedWrapper = ({
  url,
  youTubeProps,
}: {
  url: string;
  youTubeProps?: YouTubeEmbedProps['youTubeProps'];
}) => {
  const youtubeRef = useRef<HTMLDivElement>(null);
  const [youtubeWidth, setYoutubeWidth] = useState(0);
  const [youtubeHeight, setYoutubeHeight] = useState(0);

  // Adjust the YouTube embed size based on the container width
  useEffect(() => {
    const handleResize = () => {
      if (youtubeRef.current) {
        if (url.includes('shorts')) {
          const width = Math.min(youtubeRef.current.offsetWidth, maxWidth / 2);
          setYoutubeWidth(width);
          setYoutubeHeight((width / 9) * 16);
        } else {
          const width = Math.min(youtubeRef.current.offsetWidth, maxWidth);
          setYoutubeWidth(width);
          setYoutubeHeight((width / 16) * 9);
        }
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [url]);

  return (
    <div ref={youtubeRef} className={`${className}__youtube-container`}>
      <YouTubeEmbed
        url={url}
        youTubeProps={youTubeProps}
        placeholderDisabled
        width={youtubeWidth}
        height={youtubeHeight}
      />
    </div>
  );
};
